import { initDataDogRUM } from '@picsart/datadog-rum';

import DD_RUM_SDK_INITIALIZATION_PARAMETERS from './dd_params';

const initDataDog = (version: string, service: string) => {
  if (process.env.REACT_APP_DD_INIT === '1') {
    const params = DD_RUM_SDK_INITIALIZATION_PARAMETERS[service] || DD_RUM_SDK_INITIALIZATION_PARAMETERS['landings'];
    initDataDogRUM({
      ...params,
      initParams: { ...params.initParams, version },
    });
    (window as any).DD_RUM.isInitialized = true;
  }
};

export default initDataDog;
